module.exports = __webpack_public_path__ + "img/bul_info_notice.84cfa055.svg";